import { HarvestTypeFilter } from './types/withdrawals.types'

export const FILTER_OPTIONS: { value: HarvestTypeFilter; label: string }[] = [
  { value: HarvestTypeFilter.ALL, label: 'All' },
  { value: HarvestTypeFilter.LTCG, label: 'LTCG' },
  { value: HarvestTypeFilter.STCG, label: 'STCG' },
  { value: HarvestTypeFilter.LTCL, label: 'LTCL' },
  { value: HarvestTypeFilter.STCL, label: 'STCL' }
]
